export default {
  confirm: 'Bekræft',
  title: 'Kvalificerede tilbud',
};
